export const getModuleName = (path: string, index = 1): string =>
  path?.split('/')?.[index];

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleCalenderColors = (dates: any[]) => {
  return dates.map((el: any) => {
    el['backgroundColor'] = 'rgba(255,0,0,0.2)';
    if (el.value > 2) {
      el['backgroundColor'] = 'rgba(255,0,0,0.3)';
    } else if (el.value > 4) {
      el['backgroundColor'] = 'rgba(255,0,0,0.5)';
    } else if (el.value > 100) {
      el['backgroundColor'] = 'rgba(255,0,0,0.6)';
    } else if (el.value > 1000) {
      el['backgroundColor'] = 'rgba(255,0,0,0.8)';
    } else if (el.value > 10000) {
      el['backgroundColor'] = 'rgba(255,0,0,1)';
    }

    return el;
  });
};
const handleCalnderValue = (val: number): number => {
  let rgbColor = 1;
  if (val === 1) {
    return rgbColor;
  }
  if (val < 2) {
    return (rgbColor = 2);
  }
  if (val < 5) {
    return (rgbColor = 3);
  }
  if (val < 8) {
    return (rgbColor = 5);
  }
  if (val < 16) {
    return (rgbColor = 6);
  }
  if (val < 30) {
    return (rgbColor = 7);
  }
  if (val < 60) {
    return (rgbColor = 8);
  }
  return (rgbColor = 9);
};

export const newhandleCalenderColors = (dates: any[]): any[] => {
  return dates.map((el: any) => {
    el['backgroundColor'] = `rgba(255,0,0,0.${handleCalnderValue(el.value)})`;
    return el;
  });
};
